export const MenuListArray2 = [
    {
        title: 'Home',
        classChange: '',
        to: '/',
    },
    {
        title: 'About Us',
        classChange: '',
        to: '/about-us',
    },
    {
        title: 'Libraries',
        classChange: '',
        to: '/libraries',
    },
    {
        title: 'BMI Calculator',
        classChange: '',
        to: '/bmi-calculator',
    },
    {
        title: 'Nutrition Guide',
        classChange: '',
        to: '/nutrition-guide',
        feature: 'nutrition_guide',
    },
    {
        title: 'Contact Us',
        classChange: '',
        to: '/#contact',
    },
    {
        title: 'Request a Program',
        classChange: '',
        to: '/program-inquiry',
    },
    {
        title: 'My Program',
        classChange: '',
        to: '/my-program',
    },
];
